import React from 'react';

export function CardSkeletonLoader({ count = 3 }: { count?: number }) {
  return (
    <div style={{ display: 'grid', gap: '16px', minHeight: '380px' }}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="skeleton-card"
          style={{
            background: 'var(--glass-bg)',
            border: '1px solid var(--glass-border)',
            borderRadius: '18px',
            padding: '24px',
            backdropFilter: 'blur(12px)',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '16px' }}>
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '14px' }}>
                <div className="skeleton-shimmer" style={{ width: '90px', height: '24px', borderRadius: '8px' }} />
                <div className="skeleton-shimmer" style={{ width: '80px', height: '22px', borderRadius: '6px' }} />
                <div className="skeleton-shimmer" style={{ width: '60px', height: '22px', borderRadius: '6px' }} />
              </div>
              <div className="skeleton-shimmer" style={{ width: '70%', height: '14px', borderRadius: '4px', marginBottom: '8px' }} />
              <div className="skeleton-shimmer" style={{ width: '45%', height: '14px', borderRadius: '4px' }} />
            </div>
            <div className="skeleton-shimmer" style={{ width: '130px', height: '40px', borderRadius: '12px', flexShrink: 0 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function TableSkeletonLoader({ rows = 5 }: { rows?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', minHeight: '340px' }}>
      <div
        className="skeleton-shimmer"
        style={{ height: '44px', borderRadius: '12px', opacity: 0.6, marginBottom: '6px' }}
      />
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="skeleton-row"
          style={{
            height: '52px',
            background: 'rgba(255, 255, 255, 0.02)',
            borderRadius: '12px',
            border: '1px solid rgba(255, 255, 255, 0.05)',
            display: 'flex',
            alignItems: 'center',
            padding: '0 16px',
            gap: '16px',
          }}
        >
          <div className="skeleton-shimmer" style={{ width: '32px', height: '32px', borderRadius: '50%', flexShrink: 0 }} />
          <div className="skeleton-shimmer" style={{ width: '25%', height: '16px', borderRadius: '4px' }} />
          <div className="skeleton-shimmer" style={{ width: '30%', height: '16px', borderRadius: '4px' }} />
          <div className="skeleton-shimmer" style={{ width: '15%', height: '16px', borderRadius: '4px', marginLeft: 'auto' }} />
          <div className="skeleton-shimmer" style={{ width: '80px', height: '30px', borderRadius: '8px', flexShrink: 0 }} />
        </div>
      ))}
    </div>
  );
}

export function DashboardSkeletonLoader() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', minHeight: '480px' }}>
      {/* 4 Stat Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px' }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            style={{
              background: 'var(--glass-bg)',
              border: '1px solid var(--glass-border)',
              borderRadius: '20px',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="skeleton-shimmer" style={{ width: '80px', height: '14px', borderRadius: '4px' }} />
              <div className="skeleton-shimmer" style={{ width: '36px', height: '36px', borderRadius: '10px' }} />
            </div>
            <div className="skeleton-shimmer" style={{ width: '110px', height: '32px', borderRadius: '6px' }} />
            <div className="skeleton-shimmer" style={{ width: '60%', height: '12px', borderRadius: '4px' }} />
          </div>
        ))}
      </div>

      {/* 2 Large Panels */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: '20px' }}>
        {Array.from({ length: 2 }).map((_, i) => (
          <div
            key={i}
            style={{
              background: 'var(--glass-bg)',
              border: '1px solid var(--glass-border)',
              borderRadius: '20px',
              padding: '24px',
              height: '240px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
            }}
          >
            <div className="skeleton-shimmer" style={{ width: '140px', height: '20px', borderRadius: '6px' }} />
            <div className="skeleton-shimmer" style={{ flex: 1, borderRadius: '12px' }} />
          </div>
        ))}
      </div>
    </div>
  );
}

export function FormSkeletonLoader() {
  return (
    <div
      style={{
        background: 'var(--glass-bg)',
        border: '1px solid var(--glass-border)',
        borderRadius: '20px',
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        minHeight: '360px',
      }}
    >
      <div className="skeleton-shimmer" style={{ width: '180px', height: '24px', borderRadius: '6px', marginBottom: '8px' }} />
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div className="skeleton-shimmer" style={{ width: '100px', height: '14px', borderRadius: '4px' }} />
          <div className="skeleton-shimmer" style={{ width: '100%', height: '44px', borderRadius: '10px' }} />
        </div>
      ))}
      <div className="skeleton-shimmer" style={{ width: '140px', height: '46px', borderRadius: '12px', marginTop: '12px' }} />
    </div>
  );
}
